<!-- Floating FAB Button (toggle the chat)-->
<!-- Floating FAB Button (toggle the chat)-->
<button
  id="aiChatFabButton"
  mat-fab
  class="!fixed !bottom-[68px] right-6 z-[120] cursor-move bg-gradient-to-br from-ai-shade-1 to-ai-shade-2 shadow-lg transition-colors duration-300 ease-out hover:scale-105 hover:shadow-xl active:scale-95 md:!bottom-6"
  [style.visibility]="isFullscreen() || hideChatButton() ? 'hidden' : 'visible'"
  [style.pointer-events]="isFullscreen() ? 'none' : 'auto'"
  (click)="togglePrompt()"
  cdkDrag
  cdkDragBoundary="#aiChatArea"
  (cdkDragStarted)="onDragStarted()"
  (cdkDragEnded)="onDragEnded()"
>
  <img src="./assets/ai/ai-icon.svg" width="32" height="32" />
</button>

<!-- AI Chat Prompt Dialog -->
@if (showPrompt() || isFullscreen()) {
  <!-- Backdrop with subtle blur effect -->
  <div
    [class]="
      lockChatFullScreen()
        ? 'animate-in fade-in relative block h-full w-full duration-200'
        : 'animate-in fade-in fixed inset-0 z-[118] duration-200'
    "
    [class.backdrop-blur-sm]="isUserFullscreen()"
    (click)="!isFullscreen() && closePrompt()"
  >
    <!-- Main prompt container with Material Design v3 styling -->
    <div
      class="surface-lowest absolute flex flex-col overflow-hidden duration-300 ease-out"
      [style.left.px]="lockChatFullScreen() ? 0 : promptPosition.x"
      [style.top.px]="lockChatFullScreen() ? 0 : promptPosition.y"
      (click)="$event.stopPropagation()"
      [class]="
        !isUserFullscreen() && !lockChatFullScreen()
          ? 'max-h-[calc(100%-120px)] w-[calc(100%-16px)] rounded-3xl border border-solid border-[var(--ai-shade-2)] shadow-2xl backdrop-blur-md md:min-h-[280px] md:w-[600px]'
          : lockChatFullScreen()
            ? '!relative h-full w-full rounded-2xl'
            : !isMobile()
              ? 'fixed inset-2 !left-2 !top-2 z-[9999] h-[calc(100%-1rem)] w-[calc(100%-1rem)] rounded-3xl border border-solid border-[var(--ai-shade-2)] backdrop-blur-md'
              : 'fixed inset-0 z-[9999] h-full w-full'
      "
      id="aiChatPromptContainer"
    >
      <!-- Fullscreen toggle button container - positioned in top right -->
      @if (isFullscreen() && !lockChatFullScreen()) {
        @if (isMobile()) {
          <div class="absolute top-0 left-0 z-50 flex gap-2 p-2">
            <button
              mat-icon-button
              (click)="toggleMobileHistory()"
              [matTooltip]="'Cronologia' | siaTranslate"
              class="hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
            >
              <mat-icon>menu</mat-icon>
            </button>
          </div>
        }
        <div class="absolute top-0 right-0 z-50 p-2">
          <button
            mat-icon-button
            [matTooltip]="
              isMobile()
                ? ('Chiudi' | siaTranslate)
                : ('Esci da schermo intero' | siaTranslate)
            "
            (click)="isMobile() ? closePrompt() : toggleFullscreen()"
          >
            <mat-icon>{{ isMobile() ? 'close' : 'fullscreen_exit' }}</mat-icon>
          </button>
        </div>
      }

      <!-- Header with AI icon and title ONLY on page-->
      @if (showHeaderActions()) {
        <div
          class="surface-lowest relative flex items-center justify-end gap-3 px-2 pt-2 pb-0"
          s
          #headerChat
        >
          <!-- Center title when user has sent message - absolutely positioned -->
          @if (hasUserSentMessage() && selectedCollectionId()) {
            <div
              class="left-1/2 top-1/2 absolute -translate-x-1/2 -translate-y-1/2"
            >
              <div class="header-ai-assistant flex items-center gap-2">
                <div class="flex items-center justify-center w-8 h-8">
                  <img src="./assets/ai/ai-icon-alt.png" class="w-6 h-6" />
                </div>
                <span class="whitespace-nowrap text-lg font-semibold">
                  <span class="text-[var(--ai-shade-2)]">Kitsune</span> AI
                  Assistant
                </span>
              </div>
            </div>
          }

          <!-- Right section with New Chat and fullscreen buttons -->
          <div class="flex items-center justify-between w-full">
            <div class="flex items-center gap-2">
              @if (hasUserSentMessage() && selectedCollectionId()) {
                <button
                  mat-icon-button
                  (click)="newChat()"
                  [matTooltip]="'Nuova chat' | siaTranslate"
                  class="hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
                >
                  <mat-icon>add_comment</mat-icon>
                </button>
              }
              @if (isNarrow()) {
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="narrowHistoryMenu"
                  [matTooltip]="'Cronologia' | siaTranslate"
                  [disabled]="chatSessions().length <= 1"
                >
                  <mat-icon>history</mat-icon>
                </button>
                <mat-menu #narrowHistoryMenu="matMenu">
                  @for (session of chatSessions(); track session.id) {
                    <button
                      mat-menu-item
                      (click)="loadChatSession(session.id)"
                      [style.font-weight]="
                        activeChatSessionId() === session.id ? 'bold' : 'normal'
                      "
                    >
                      <mat-icon>chat</mat-icon>
                      <span>{{ session.title }}</span>
                    </button>
                  }
                </mat-menu>
              }
            </div>
            @if (!hideFullscreenButton() && !lockChatFullScreen()) {
              <button
                mat-icon-button
                [matTooltip]="'Schermo intero' | siaTranslate"
                (click)="toggleFullscreen()"
                class="hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
                [class.ml-auto]="
                  !hasUserSentMessage() || !selectedCollectionId()
                "
              >
                <mat-icon>fullscreen</mat-icon>
              </button>
            }
          </div>
        </div>
      }
      <!-- Main content area with sidebar layout -->
      <!-- Main content area with new layout for fullscreen modes -->
      <div class="relative flex flex-row h-full min-h-0">
        @if (
          (isFullscreen() || lockChatFullScreen()) &&
          (!isMobile() || showMobileHistory()) &&
          !isNarrow()
        ) {
          @if (isMobile() && showMobileHistory()) {
            <div
              class="bg-black/50 fixed inset-0 z-50"
              (click)="showMobileHistory.set(false)"
            ></div>
          }
          <!-- New left sidebar for chat history when in fullscreen - hidden on mobile -->
          <div
            class="w-80 flex flex-col flex-shrink-0 py-4"
            [class]="
              isMobile()
                ? 'surface-low animate-in slide-in-from-left absolute left-0 z-[60] my-4 h-[calc(100%-2rem)] rounded-r-2xl duration-300 ease-out'
                : 'surface-lowest'
            "
          >
            <!-- Top area with New Chat button -->
            <div
              class="p-4"
              [class]="
                !isMobile()
                  ? 'border-r border-solid border-[var(--mat-sys-outline)]'
                  : ''
              "
            >
              <button
                mat-button
                (click)="newChat()"
                class="hover:bg-gray-100 dark:hover:bg-gray-700 flex items-center justify-center w-full gap-2 py-3 transition-colors duration-200 rounded-lg"
              >
                <mat-icon>add_comment</mat-icon>
                <span class="text-sm font-medium">{{
                  'New Chat' | siaTranslate
                }}</span>
              </button>
              <!-- Separator line that doesn't span full width -->
              <div
                class="mx-4 mt-4 border-b border-solid border-[var(--mat-sys-outline-variant)]"
              ></div>
            </div>

            <!-- Scrollable area for chat history -->
            <div
              class="flex-1 px-4 overflow-y-auto"
              [class]="
                !isMobile()
                  ? 'border-r border-solid border-[var(--mat-sys-outline)]'
                  : ''
              "
            >
              <!-- Chat history list -->
              <div class="space-y-2">
                @for (session of chatSessions(); track session.id) {
                  <div
                    class="p-3 transition-colors duration-200 ease-in rounded-lg cursor-pointer"
                    [style.background]="
                      activeChatSessionId() === session.id
                        ? 'var(--ai-shade-2)'
                        : ''
                    "
                    [style.color]="
                      activeChatSessionId() === session.id ? 'white' : ''
                    "
                    [class.surface-high]="activeChatSessionId() !== session.id"
                    [class.hover:surface-highest]="
                      activeChatSessionId() !== session.id
                    "
                    (click)="loadChatSession(session.id)"
                  >
                    <div
                      class="text-sm font-medium truncate"
                      [class.text-white]="activeChatSessionId() === session.id"
                      [class.text-gray-900]="
                        activeChatSessionId() !== session.id
                      "
                      [class.dark:text-gray-100]="
                        activeChatSessionId() !== session.id
                      "
                    >
                      {{ session.title }}
                    </div>
                    <div
                      class="mt-1 text-xs"
                      [class.text-gray-200]="
                        activeChatSessionId() === session.id
                      "
                      [class.text-gray-500]="
                        activeChatSessionId() !== session.id
                      "
                      [class.dark:text-gray-400]="
                        activeChatSessionId() !== session.id
                      "
                    >
                      {{ session.lastActivity | date: 'MMM d, h:mm a' }}
                    </div>
                  </div>
                } @empty {
                  <div
                    class="dark:text-gray-400 mt-8 text-sm text-center text-gray-500"
                  >
                    {{ 'Nessuna chat precedente' | siaTranslate }}
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <!-- Main chat area -->
        <div
          class="flex flex-col flex-1 h-full min-w-0"
          [class.p-2]="isMobile() || (!isFullscreen() && !lockChatFullScreen())"
          [class.p-4]="!isMobile() && (isFullscreen() || lockChatFullScreen())"
        >
          <!-- Title for fullscreen modes - outside scroll area -->
          @if (
            !lockChatFullScreen() &&
            isFullscreen() &&
            !isNarrow() &&
            hasUserSentMessage() &&
            selectedCollectionId()
          ) {
            <div
              class="flex items-center justify-center flex-shrink-0"
              [class]="isMobile() ? 'py-1' : 'py-4'"
            >
              <div class="flex items-center gap-2">
                <div class="flex items-center justify-center w-8 h-8">
                  <img src="./assets/ai/ai-icon-alt.png" class="w-6 h-6" />
                </div>
                <span class="text-lg font-semibold">
                  <span class="text-[var(--ai-shade-2)]">Kitsune</span> AI
                  Assistant
                </span>
              </div>
            </div>
          }

          <!-- Chat content area (scrollable) -->
          <div
            class="flex-1 min-h-0 overflow-y-auto"
            id="chatContainer"
            #chatContainer
            [class.justify-center]="
              (isFullscreen() || lockChatFullScreen()) &&
              (!hasUserSentMessage() || !selectedCollectionId())
            "
            [class.flex]="
              (isFullscreen() || lockChatFullScreen()) &&
              (!hasUserSentMessage() || !selectedCollectionId())
            "
            [class.flex-col]="
              (isFullscreen() || lockChatFullScreen()) &&
              (!hasUserSentMessage() || !selectedCollectionId())
            "
          >
            <!-- Initial welcome content - shown when no messages have been sent -->
            @if (!hasUserSentMessage() || !selectedCollectionId()) {
              <div
                class="chat-initial-content flex flex-col items-center justify-center gap-6"
                [class.h-full]="isFullscreen() || lockChatFullScreen()"
              >
                <div class="flex flex-col items-center gap-4">
                  @if (!lockChatFullScreen()) {
                    <h3
                      class="dark:text-gray-100 flex gap-2 text-lg font-medium text-gray-900"
                    >
                      <span class="text-[var(--ai-shade-2)]">Kitsune</span>
                      <p>{{ 'AI Assistant' | siaTranslate }}</p>
                    </h3>
                  }
                  <p class="text-2xl font-semibold">
                    {{ 'Come posso aiutarti?' | siaTranslate }}
                  </p>
                  <div class="flex items-center justify-center w-32 h-32">
                    <img src="./assets/ai/ai-icon-alt.png" />
                  </div>
                </div>

                <!-- Collection selection buttons - only show when no collection is selected -->
                @if (!selectedCollectionId()) {
                  <div
                    class="flex flex-row flex-wrap justify-center max-w-4xl gap-4 px-4 pb-6"
                  >
                    @for (
                      outlet of filteredCollections() | keyvalue;
                      track outlet.key
                    ) {
                      @for (collection of outlet.value; track collection.id) {
                        <span
                          class="flex min-w-[180px] max-w-[280px] flex-1 items-center justify-start gap-4 rounded-xl px-4 py-3 text-center transition-[background] duration-300"
                          [class.cursor-pointer]="!isCollectionLocked()"
                          [class.cursor-not-allowed]="isCollectionLocked()"
                          [class.opacity-50]="
                            isCollectionLocked() &&
                            collection.id !== selectedCollectionId()
                          "
                          [style.background]="
                            collection.id === selectedCollectionId()
                              ? 'var(--ai-shade-2)'
                              : ''
                          "
                          [style.color]="
                            collection.id === selectedCollectionId()
                              ? 'var(--ai-on-shade)'
                              : ''
                          "
                          [class.font-semibold]="
                            collection.id === selectedCollectionId()
                          "
                          [class.surface-high]="
                            collection.id !== selectedCollectionId() &&
                            !isCollectionLocked()
                          "
                          (click)="
                            !isCollectionLocked() &&
                              useMCPCollection(collection.id, outlet.key)
                          "
                        >
                          <div
                            class="flex h-10 min-w-[2.5rem] items-center justify-center rounded-md bg-[var(--ai-shade-2)] p-1.5"
                          >
                            <mat-icon class="text-lg text-white">{{
                              collection.icon
                            }}</mat-icon>
                          </div>

                          <span class="text-sm font-medium">
                            {{ collection.description | siaTranslate }}
                            {{ routeDataForOutlet()[outlet.key]?.menu?.title }}
                          </span>
                        </span>
                      }
                    }
                  </div>
                } @else {
                  <!-- Help message when collection is selected but no messages yet-->
                  @if (!hasUserSentMessage()) {
                    <div
                      class="flex min-h-[120px] flex-col items-center justify-center gap-2 px-4 py-8 text-center"
                    >
                      <p class="dark:text-gray-400 text-sm text-gray-600">
                        {{
                          'Scrivi il tuo messaggio qui sotto per iniziare a chattare con'
                            | siaTranslate
                        }}
                        <span class="text-ai-shade-2 font-medium">{{
                          selectedCollection()?.description | siaTranslate
                        }}</span>
                      </p>
                    </div>
                  }
                }
              </div>
            }

            @if (
              selectedCollection()?.originCategories &&
              selectedCollection()!.originCategories!.length > 0
            ) {
              <div class="flex flex-row gap-1 px-4">
                @for (
                  category of selectedCollection()!.originCategories!;
                  track category
                ) {
                  <span
                    class="flex w-fit items-center gap-1 rounded-lg px-2 py-1 font-semibold transition-[background] duration-300"
                    [style.background]="category.color"
                    [colorContrastAuto]="true"
                    contrastMode="adaptive"
                  >
                    <mat-icon class="sm">{{ category.icon }}</mat-icon>
                    <span class="text-xs font-medium">{{
                      category.description | siaTranslate
                    }}</span>
                  </span>
                }
              </div>
            }

            <!-- Chat history panel - only show when there are messages -->
            @if (
              activeChatSessionId() &&
              chatHistory()[activeChatSessionId()] &&
              chatHistory()[activeChatSessionId()].length > 0
            ) {
              <div
                class="ovreflow-y-auto h-fit flex flex-col w-full min-h-0"
                [class]="
                  isMobile() || (!isFullscreen() && !lockChatFullScreen())
                    ? 'p-1'
                    : 'p-4'
                "
                [style.max-height]="
                  !isFullscreen() && !lockChatFullScreen() ? '30vh' : ''
                "
                [style.min-height]="
                  !isFullscreen() && !lockChatFullScreen() ? '260px' : '0'
                "
              >
                @for (
                  msg of chatHistory()[this.activeChatSessionId()];
                  track msg;
                  let isLast = $last
                ) {
                  <div
                    class="flex flex-col w-full gap-2 mb-2"
                    (ngInit)="scrollChatContainerToBottom()"
                    [isLast]="isLast"
                  >
                    <div
                      class="bg-secondary ml-auto flex max-w-[90%] flex-col rounded-lg p-2"
                    >
                      <!-- <span class="text-ai-shade-2 font-semibold">
                        {{ 'Tu' | siaTranslate }}:</span
                      > -->
                      <span>
                        {{ msg.user }}
                      </span>

                      <div class="flex flex-row flex-wrap gap-2 mt-1">
                        @for (file of msg.attachedDocuments; track file) {
                          <div
                            class="flex min-w-[150px] max-w-[50%] flex-row items-center gap-1 rounded-md border border-solid px-2 py-1 text-sm font-medium transition-all duration-300 ease-in-out"
                            [matTooltip]="file.fileName"
                            matTooltipPosition="above"
                          >
                            <mat-icon class="sm">image </mat-icon>
                            <span class="w-[calc(100%-24px)] truncate">
                              {{ file.fileName }}
                            </span>
                          </div>
                        }
                      </div>
                    </div>
                    <div
                      class="ai-chat-assistant-message surface flex max-w-[90%] flex-col rounded-lg p-2"
                    >
                      <!-- <span
                        class="text-ai-shade-2 dark:text-ai-shade-2 font-semibold"
                      >
                        Kitsune:
                      </span> -->
                      <div class="h-fit w-full overflow-auto">
                        @if (msg.isLoading) {
                          <div class="flex items-center gap-2 py-2">
                            <div
                              class="loading-spinner loading-spinner--surface"
                            ></div>
                            <span
                              class="typewriter-text dark:text-gray-400 text-sm font-semibold text-gray-600"
                              [class.pulse-text]="siaAILoadingTextIsPulsing()"
                              >{{ siaAILoadingText() | siaTranslate }}</span
                            >
                          </div>
                        } @else {
                          <div
                            [innerHTML]="
                              msg.aiSanitized
                                | markdownWithColor
                                  : getMarkdownContext(msg.chatUniqueId!)
                                | async
                            "
                            class="markdown-content"
                            (click)="
                              onMessageContentClick($event, msg.chatUniqueId!)
                            "
                          ></div>
                        }
                      </div>

                      <!-- Removed origin documents display from here - now shown in dedicated section -->
                    </div>
                  </div>
                }
              </div>
            }
          </div>

          <!-- Reference Documents Section - show when session has reference documents -->
          @if (hasCurrentSessionReferenceDocuments()) {
            <div
              class="from-[var(--ai-shade-2)]/5 to-[var(--ai-shade-2)]/10 flex-shrink-0 border-t border-solid border-[var(--ai-shade-2)] bg-gradient-to-r pt-3"
              [class.px-4]="!isFullscreen() && !lockChatFullScreen()"
              [class.px-0]="isFullscreen() || lockChatFullScreen()"
            >
              <div class="flex flex-col gap-3">
                <div class="flex items-center gap-2">
                  <mat-icon class="text-sm text-[var(--ai-shade-2)]"
                    >link</mat-icon
                  >
                  <span class="text-sm font-semibold text-[var(--ai-shade-2)]">
                    {{
                      'Documenti di riferimento per questa chat' | siaTranslate
                    }}
                  </span>
                  <span class="text-xs text-[var(--ai-shade-2)] opacity-75">
                    ({{ currentSessionReferenceDocuments().length }})
                  </span>
                </div>

                <!-- Reference Documents Grid - non-selectable, just informational -->
                <div
                  class="h-fit pt-1 pr-2"
                  [class]="
                    isMobile()
                      ? 'overflow-x-auto overflow-y-hidden'
                      : 'overflow-y-auto'
                  "
                  [style.max-height]="isMobile() ? 'unset' : '140px'"
                  [style.-webkit-overflow-scrolling]="
                    isMobile() ? 'touch' : 'auto'
                  "
                >
                  <div
                    [class]="
                      isMobile()
                        ? 'flex flex-nowrap gap-2'
                        : isFullscreen() || lockChatFullScreen()
                          ? 'grid grid-cols-3 gap-2'
                          : 'grid grid-cols-2 gap-2'
                    "
                  >
                    @for (
                      refDoc of currentSessionReferenceDocuments();
                      track refDoc.fileSha256
                    ) {
                      <div
                        class="surface-high group relative flex cursor-pointer items-center gap-2 rounded-md border-2 border-solid border-[var(--ai-shade-2)] p-2 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-md active:translate-y-0"
                        [class.min-w-[250px]]="isMobile()"
                        [class.flex-shrink-0]="isMobile()"
                        [style.background]="
                          'color-mix(in srgb, var(--ai-shade-2) 8%, transparent)'
                        "
                        [style.max-width]="isMobile() ? 'none' : '100%'"
                        [siaTooltip]="
                          ('Clicca per aprire: ' | siaTranslate) +
                          refDoc.fileName +
                          (refDoc.position ? ' - ' + refDoc.position : '')
                        "
                        [disableTranslation]="true"
                        position="top"
                        (click)="previewDocument(refDoc)"
                      >
                        <!-- Lock Icon to indicate this is a reference document -->
                        <mat-icon
                          class="flex-shrink-0 text-sm text-[var(--ai-shade-2)]"
                        >
                          lock
                        </mat-icon>

                        <!-- Document Icon -->
                        <mat-icon
                          class="flex-shrink-0 text-base"
                          [style.color]="refDoc.color"
                        >
                          {{ refDoc.icon }}
                        </mat-icon>

                        <!-- Document Name -->
                        <div class="flex-1 min-w-0">
                          <div
                            class="truncate text-xs font-medium text-[var(--ai-shade-2)]"
                          >
                            {{ refDoc.fileName }}
                          </div>
                          @if (refDoc.position) {
                            <div
                              class="truncate text-xs text-[var(--ai-shade-2)] opacity-75"
                            >
                              {{ refDoc.position }}
                            </div>
                          }
                        </div>

                        <!-- Open/Preview Icon -->
                        <mat-icon
                          class="flex-shrink-0 text-sm text-[var(--ai-shade-2)] opacity-0 transition-opacity duration-200 group-hover:opacity-100"
                          (click)="previewDocument(refDoc)"
                        >
                          open_in_new
                        </mat-icon>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }

          <!-- Session Documents Section - show before input when there are documents -->
          @if (
            !hasCurrentSessionReferenceDocuments() &&
            currentSessionDocuments().length > 0
          ) {
            <div
              class="flex-shrink-0 border-t border-solid border-[var(--mat-sys-outline-variant)] pt-3"
              [class.px-4]="!isFullscreen() && !lockChatFullScreen()"
              [class.px-0]="isFullscreen() || lockChatFullScreen()"
            >
              <div
                class="flex flex-col"
                [class]="isMobile() ? 'gap-1' : 'gap-3'"
              >
                <div class="flex items-center gap-2">
                  <mat-icon class="text-sm text-[var(--ai-shade-2)]"
                    >description</mat-icon
                  >
                  <span
                    class="dark:text-gray-300 text-sm font-medium text-gray-700"
                  >
                    {{ 'Documenti di riferimento' | siaTranslate }}
                  </span>
                  <span class="dark:text-gray-400 text-xs text-gray-500">
                    ({{ currentSessionDocuments().length }})
                  </span>
                </div>

                <!-- Documents Grid with scrollable container (max 2 rows) -->
                <div
                  class="pt-1 pr-2"
                  [style.max-height]="isMobile() ? 'unset' : '140px'"
                  [class]="
                    isMobile()
                      ? 'overflow-x-auto overflow-y-hidden'
                      : 'overflow-y-auto'
                  "
                >
                  <div
                    [class]="
                      isMobile()
                        ? 'flex flex-nowrap gap-2'
                        : isFullscreen() || lockChatFullScreen()
                          ? 'grid grid-cols-3 gap-2'
                          : 'grid grid-cols-2 gap-2'
                    "
                  >
                    @for (
                      origin of currentSessionDocuments();
                      track origin.fileSha256
                    ) {
                      <div
                        class="surface-high group hover:shadow-md relative flex items-center gap-2 p-2 transition-all duration-200 rounded-md cursor-pointer"
                        [class.min-w-[250px]]="isMobile()"
                        [class.flex-shrink-0]="isMobile()"
                        [class.border-2]="
                          isDocumentSelected(origin.fileSha256!)
                        "
                        [class.border-primary]="
                          isDocumentSelected(origin.fileSha256!)
                        "
                        [class.border-solid]="
                          isDocumentSelected(origin.fileSha256!)
                        "
                        [class.border]="!isDocumentSelected(origin.fileSha256!)"
                        [class.border-[var(--mat-sys-outline)]]="
                          !isDocumentSelected(origin.fileSha256!)
                        "
                        [style.background]="
                          isDocumentSelected(origin.fileSha256!)
                            ? 'color-mix(in srgb, var(--mat-sys-primary) 5%, transparent)'
                            : ''
                        "
                        [style.max-width]="isMobile() ? 'none' : '100%'"
                        [siaTooltip]="
                          origin.fileName +
                          (origin.position ? ' - ' + origin.position : '')
                        "
                        [disableTranslation]="true"
                        position="top"
                        (click)="previewDocument(origin)"
                      >
                        <!-- Checkbox -->
                        <mat-checkbox
                          [checked]="isDocumentSelected(origin.fileSha256!)"
                          (change)="toggleDocumentSelection(origin.fileSha256!)"
                          (click)="$event.stopPropagation()"
                          class="flex-shrink-0 scale-75"
                        ></mat-checkbox>

                        <!-- Document Icon -->
                        <mat-icon
                          class="flex-shrink-0 text-base"
                          [style.color]="origin.color"
                        >
                          {{ origin.icon }}
                        </mat-icon>

                        <!-- Document Name -->
                        <div class="flex-1 min-w-0">
                          <div class="text-xs font-medium truncate">
                            {{ origin.fileName }}
                          </div>
                          @if (origin.position) {
                            <div
                              class="dark:text-gray-400 text-xs text-gray-500 truncate"
                            >
                              {{ origin.position }}
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>

                <!-- Chat with Selected Documents Button -->
                @if (hasSelectedDocuments()) {
                  <div class="flex justify-center pt-2">
                    <button
                      mat-flat-button
                      (click)="chatWithSelectedDocuments()"
                      style="background: var(--ai-shade-2); color: white"
                      class="hover:opacity-90 transition-opacity"
                    >
                      <mat-icon class="mr-2 text-base">chat</mat-icon>
                      {{ 'Chatta con i documenti selezionati' | siaTranslate }}
                      ({{ selectedDocuments().size }})
                    </button>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Chat input area - now in normal flow at bottom -->
          <div
            class="flex-shrink-0 pt-4"
            [class.px-4]="!isFullscreen() && !lockChatFullScreen()"
            [class.pb-2]="!isFullscreen() && !lockChatFullScreen()"
            [class.px-0]="isFullscreen() || lockChatFullScreen()"
          >
            <div
              class="surface h-fit rounded-2xl ring-transparent focus:ring-2 focus:ring-ai-shade-2 flex flex-col w-full gap-4"
              #chatInputContainer
            >
              <div class="flex flex-row items-center gap-2 space-y-3">
                <div class="relative flex flex-col items-center w-full gap-2">
                  <div
                    class="flex flex-col w-full p-4 overflow-hidden outline-none"
                  >
                    <textarea
                      #chatInputTextArea
                      [(ngModel)]="chatInput"
                      [disabled]="
                        chatLoading()[this.activeChatSessionId()] ||
                        !selectedCollectionId
                      "
                      [placeholder]="
                        (chatLoading()[this.activeChatSessionId()]
                          ? 'Attendi una risposta...'
                          : !selectedCollectionId
                            ? 'Nessun tool disponibile...'
                            : 'Scrivi qui il tuo messaggio...'
                        ) | siaTranslate
                      "
                      cdkTextareaAutosize
                      [cdkAutosizeMinRows]="isMobile() ? 1 : 1"
                      [cdkAutosizeMaxRows]="isMobile() ? 6 : 6"
                      class="surface ring-transparent w-full text-sm transition-all duration-200 border-transparent outline-none resize-none"
                      (keydown)="onTextareaKeydown($event)"
                    ></textarea>
                    <div class="flex flex-row flex-wrap gap-2 mt-1">
                      @for (file of currentUploadedFiles(); track file) {
                        <div
                          class="surface-highest flex w-[calc(50%-.5rem)] flex-row items-center gap-1 rounded-md p-1 text-sm font-medium transition-all duration-300 ease-in-out md:min-w-[150px] md:max-w-[30%]"
                          [matTooltip]="file.fileName"
                          matTooltipPosition="above"
                        >
                          <mat-icon class="sm">image </mat-icon>
                          <span class="w-[calc(100%-48px)] truncate">
                            {{ file.fileName }}
                          </span>

                          <mat-icon
                            class="sm error cursor-pointer"
                            (click)="removeFile(file.fileName ?? '')"
                            >cancel
                          </mat-icon>
                        </div>
                      }
                    </div>
                  </div>
                  <div
                    class="flex items-center justify-between w-full px-4 pb-2"
                  >
                    <button
                      mat-button
                      [matMenuTriggerFor]="collectionMenu"
                      class="!min-w-0 !justify-start !px-3 !py-2 !text-left"
                      [disabled]="
                        chatLoading()[this.activeChatSessionId()] ||
                        isCollectionLocked()
                      "
                      [matTooltip]="
                        isCollectionLocked()
                          ? hasCurrentSessionReferenceDocuments()
                            ? ('Contesto bloccato ai documenti di riferimento - crea una nuova chat per cambiare'
                              | siaTranslate)
                            : ('Contesto selezionato - crea una nuova chat per cambiare'
                              | siaTranslate)
                          : ''
                      "
                      matTooltipPosition="above"
                    >
                      <div class="flex items-center w-full gap-2">
                        @if (!selectedCollection()) {
                          <mat-icon class="text-gray-500">filter_list</mat-icon>
                        }
                        <span class="flex-1 truncate">
                          @if (selectedCollection()) {
                            <span class="flex items-center gap-2">
                              <mat-icon class="text-sm">{{
                                selectedCollection()?.icon
                              }}</mat-icon>
                              @if (isCollectionLocked() && !isMobile()) {
                                <mat-icon
                                  class="text-sm text-[var(--ai-shade-2)]"
                                  >lock</mat-icon
                                >
                              }
                              @if (!isMobile()) {
                                {{
                                  selectedCollection()?.description
                                    | siaTranslate
                                }}
                              }
                              @if (
                                routeDataForOutlet()[selectedOutlet()]?.menu
                                  ?.title && !isMobile()
                              ) {
                                -
                                {{
                                  routeDataForOutlet()[selectedOutlet()]?.menu
                                    ?.title | siaTranslate
                                }}
                              }
                            </span>
                          } @else {
                            <span class="text-gray-500">{{
                              'Contesto' | siaTranslate
                            }}</span>
                          }
                        </span>
                        <mat-icon class="text-gray-400">expand_more</mat-icon>
                      </div>
                    </button>

                    <mat-menu #collectionMenu="matMenu" class="collection-menu">
                      @for (
                        outlet of filteredCollections() | keyvalue;
                        track outlet.key
                      ) {
                        @for (collection of outlet.value; track collection.id) {
                          <button
                            mat-menu-item
                            [disabled]="isCollectionLocked()"
                            (click)="
                              !isCollectionLocked() &&
                                useMCPCollection(collection.id, outlet.key)
                            "
                            [style.color]="
                              collection.id === selectedCollectionId() &&
                              selectedOutlet() === outlet.key
                                ? 'var(--ai-shade-2)'
                                : ''
                            "
                          >
                            <div class="flex items-center gap-2">
                              <mat-icon
                                class="text-sm"
                                [style.color]="
                                  collection.id === selectedCollectionId() &&
                                  selectedOutlet() === outlet.key
                                    ? 'var(--ai-shade-2)'
                                    : ''
                                "
                                >{{ collection.icon }}</mat-icon
                              >
                              <span>
                                {{ collection.description | siaTranslate }}
                                @if (
                                  routeDataForOutlet()[outlet.key]?.menu?.title
                                ) {
                                  -
                                  {{
                                    routeDataForOutlet()[outlet.key]?.menu
                                      ?.title | siaTranslate
                                  }}
                                }
                              </span>
                            </div>
                          </button>
                        }
                      }
                    </mat-menu>

                    <div class="flex items-center gap-1" #button>
                      <!-- AI Context Tree Selection Button - only show when collection has tree categories -->
                      @if (hasTreeCategories()) {
                        <button
                          mat-icon-button
                          [matMenuTriggerFor]="categoryTreeMenu"
                          [matTooltip]="'Seleziona contesti AI' | siaTranslate"
                          [disabled]="chatLoading()[this.activeChatSessionId()]"
                        >
                          <mat-icon class="text-xl">account_tree</mat-icon>
                        </button>
                      }

                      @if (voiceToTextService.isSupported) {
                        <button
                          #button
                          mat-icon-button
                          title="Input vocale"
                          [disabled]="
                            chatLoading()[this.activeChatSessionId()] ||
                            !selectedCollectionId
                          "
                          [class]="voiceToTextService.started ? 'primary' : ''"
                          (click)="toggleVoiceInput()"
                        >
                          <mat-icon class="text-xl">mic</mat-icon>
                        </button>
                      }
                      <button
                        #button
                        mat-icon-button
                        title="Allegati"
                        [disabled]="
                          chatLoading()[this.activeChatSessionId()] ||
                          !selectedCollectionId
                        "
                        (click)="fileInput.click()"
                      >
                        <mat-icon class="text-xl">attach_file</mat-icon>
                      </button>

                      <input
                        type="file"
                        #fileInput
                        style="display: none"
                        (change)="onFileSelected($event)"
                        [accept]="fileTypeAccepted.join(',')"
                      />
                      <!-- @if (isFullscreen()) { -->
                      <div
                        [matTooltip]="
                          !selectedCollectionId()
                            ? ('Scegli una categoria per poter chattare'
                              | siaTranslate)
                            : chatLoading()[this.activeChatSessionId()]
                              ? ('Clicca per fermare la risposta'
                                | siaTranslate)
                              : ('Invia messaggio' | siaTranslate)
                        "
                        matTooltipPosition="above"
                      >
                        <button
                          mat-icon-button
                          [style.background]="
                            chatLoading()[this.activeChatSessionId()]
                              ? 'var(--ai-shade-2)'
                              : selectedCollectionId() && chatInput.trim()
                                ? 'var(--ai-shade-2)'
                                : selectedCollectionId()
                                  ? '#d1d5db'
                                  : ''
                          "
                          [style.color]="
                            chatLoading()[this.activeChatSessionId()] ||
                            (selectedCollectionId() && chatInput.trim())
                              ? 'white'
                              : selectedCollectionId()
                                ? '#6b7280'
                                : ''
                          "
                          (click)="sendPrompt()"
                          [disabled]="
                            chatLoading()[this.activeChatSessionId()]
                              ? false
                              : !chatInput.trim() || !selectedCollectionId()
                          "
                        >
                          @if (chatLoading()[this.activeChatSessionId()]) {
                            <mat-icon> stop </mat-icon>
                            <!-- <div
                            class="loading-spinner loading-spinner--surface"
                          ></div> -->
                          } @else if (!selectedCollectionId()) {
                            <mat-icon> help_outline </mat-icon>
                          } @else {
                            <mat-icon> arrow_upward </mat-icon>
                          }
                        </button>
                      </div>
                      <!-- } -->
                    </div>

                    <!-- AI Context Tree Menu -->
                    <mat-menu
                      #categoryTreeMenu="matMenu"
                      class="category-tree-menu min-w-[300px] max-w-[800px]"
                    >
                      <div
                        class="h-full w-full min-w-[300px] p-4"
                        (click)="$event.stopPropagation()"
                      >
                        <h4
                          class="dark:text-gray-300 mb-3 text-sm font-semibold text-gray-700"
                        >
                          {{ 'Affina ricerca' | siaTranslate }}
                        </h4>
                        <div class="max-h-[400px] overflow-y-auto">
                          <mat-tree
                            [dataSource]="treeDataSource"
                            [treeControl]="treeControl"
                          >
                            <!-- Tree node template for parent nodes with children -->
                            <mat-nested-tree-node
                              *matTreeNodeDef="let node; when: hasChild"
                            >
                              <div class="tree-node">
                                <div
                                  class="sia-hover flex items-center w-full py-1 rounded"
                                  matTreeNodeToggle
                                >
                                  <!-- Expand/collapse button -->
                                  <button
                                    mat-icon-button
                                    matTreeNodeToggle
                                    class="!h-6 !w-6 !min-w-0 flex-shrink-0"
                                  >
                                    <mat-icon class="text-base">
                                      {{
                                        treeControl.isExpanded(node)
                                          ? 'expand_more'
                                          : 'chevron_right'
                                      }}
                                    </mat-icon>
                                  </button>

                                  <!-- Checkbox -->
                                  <mat-checkbox
                                    [checked]="isChecked(node.id)"
                                    [indeterminate]="isIndeterminate(node)"
                                    (change)="
                                      toggleParentCategory(node, $event)
                                    "
                                    (click)="$event.stopPropagation()"
                                    class="mr-2 scale-90"
                                  >
                                  </mat-checkbox>

                                  <!-- Icon and label -->
                                  <mat-icon
                                    class="flex-shrink-0 mr-2 text-sm"
                                    [style.color]="node.color"
                                  >
                                    {{ node.icon }}
                                  </mat-icon>
                                  <span class="text-sm font-medium">{{
                                    node.description | siaTranslate
                                  }}</span>
                                </div>

                                <!-- Children container -->
                                <div
                                  [class.tree-invisible]="
                                    !treeControl.isExpanded(node)
                                  "
                                  class="ml-8"
                                  role="group"
                                >
                                  <ng-container
                                    matTreeNodeOutlet
                                  ></ng-container>
                                </div>
                              </div>
                            </mat-nested-tree-node>

                            <!-- Tree node template for leaf nodes (no children) -->
                            <mat-tree-node
                              *matTreeNodeDef="let node"
                              class="sia-hover flex items-center w-full py-1 rounded"
                            >
                              <mat-checkbox
                                [checked]="isChecked(node.id)"
                                (change)="toggleCategory(node.id)"
                                (click)="$event.stopPropagation()"
                                class="mr-2 scale-90"
                              >
                              </mat-checkbox>
                              @if (node.icon) {
                                <mat-icon
                                  class="flex-shrink-0 mr-2 text-sm"
                                  [style.color]="node.color"
                                >
                                  {{ node.icon }}
                                </mat-icon>
                              }
                              <span class="text-sm">{{
                                node.description | siaTranslate
                              }}</span>
                            </mat-tree-node>
                          </mat-tree>
                        </div>
                      </div>
                    </mat-menu>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- Hidden trigger for document reference menu -->
<div
  style="position: fixed; visibility: hidden; pointer-events: none"
  [style.left]="docMenuPosition().x"
  [style.top]="docMenuPosition().y"
  [matMenuTriggerFor]="docReferenceMenu"
  #docReferenceMenuTrigger="matMenuTrigger"
></div>

<!-- Document reference selection menu -->
<mat-menu
  #docReferenceMenu="matMenu"
  class="doc-reference-menu !min-w-fit !max-w-[400px]"
>
  @for (doc of docMenuDocuments(); track doc.fileSha256) {
    <button
      mat-menu-item
      (click)="openDocumentFromMenu(doc)"
      class="flex items-center w-full gap-1"
    >
      <mat-icon class="flex-shrink-0 text-base" [style.color]="doc.color">
        {{ doc.icon }}
      </mat-icon>
      <div class="flex flex-col flex-1 w-full min-w-0 text-sm">
        <span class="text-sm font-medium truncate">{{ doc.fileName }}</span>
        @if (doc.position) {
          <span class="dark:text-gray-400 text-xs text-gray-500 truncate">{{
            doc.position
          }}</span>
        }
      </div>
    </button>
  }
</mat-menu>

@if (selectedPreviewDocument()) {
  <ai-preview-handler
    [fileSha256]="selectedPreviewDocument()!.fileSha256 ?? ''"
    [fileName]="selectedPreviewDocument()!.fileName ?? ''"
    [fileType]="selectedPreviewDocument()!.fileType ?? ''"
    [isFullscreenMode]="true"
    (isFullscreenModeChange)="selectedPreviewDocument.set(null)"
    [horizontal]="false"
  ></ai-preview-handler>
}
